import {CloseOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';

/* Normalize value → always return array */
const normalizeToArray = value => {
  if (!value) {return [];}
  if (Array.isArray(value)) {return value;}
  return String(value)
    .split(',')
    .map(i => i.trim())
    .filter(i => i.length > 0);
};

const SelectedFilters = ({filters, setFilters, resetFilters}) => {

  const removeFilter = (type, value) => {
    if (type === 'jewelryType' || type === 'productType') {
      setFilters(prev => ({
        ...prev,
        [type]: normalizeToArray(prev[type]).filter(item => item !== value),
      }));
    }

    if (type === 'minPrice') {
      setFilters(prev => ({...prev, minPrice: ''}));
    }

    if (type === 'maxPrice') {
      setFilters(prev => ({...prev, maxPrice: ''}));
    }
  };

  const jewelryTypes = normalizeToArray(filters?.jewelryType);
  const productTypes = normalizeToArray(filters?.productType);

  return (
    <div className={'bg-white p-3 rounded flex flex-row items-center justify-between'}>
      <div className={'flex flex-wrap gap-2'}>

        {/* Jewelry Types */}
        {jewelryTypes.map(type => (
          <div
            key={type}
            className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}
          >
            {type}
            <CloseOutlined
              className={'cursor-pointer text-xs ml-2'}
              onClick={() => removeFilter('jewelryType', type)}
            />
          </div>
        ))}

        {/* Product Types */}
        {productTypes.map(type => (
          <div
            key={type}
            className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}
          >
            {type}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() => removeFilter('productType', type)}
            />
          </div>
        ))}

        {/* Min Price */}
        {filters.minPrice !== '' && (
          <div className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}>
            Min: {filters.minPrice}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() => removeFilter('minPrice')}
            />
          </div>
        )}

        {/* Max Price */}
        {filters.maxPrice !== '' && (
          <div className={'bg-primary-200 px-3 py-1 rounded-xl flex items-center gap-1 text-sm'}>
            Max: {filters.maxPrice}
            <CloseOutlined
              className={'cursor-pointer text-xs'}
              onClick={() => removeFilter('maxPrice')}
            />
          </div>
        )}
      </div>

      {/* Clear All Button */}
      {(jewelryTypes.length > 0 ||
        productTypes.length > 0 ||
        filters.minPrice ||
        filters.maxPrice) && (
        <button
          onClick={resetFilters}
          className={'text-red-500 text-sm underline ml-4'}
        >
          Clear All
        </button>
      )}
    </div>
  );
};

SelectedFilters.propTypes = {
  filters: PropTypes.shape({
    jewelryType: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    productType: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    minPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  setFilters: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
};

export default SelectedFilters;
